import React from "react";
import { Link } from "react-router-dom";
import { Tasklist } from "./Table";
import "./Employeeworkspace.css";

const Employeeworkspace = () => {
  const workspace = JSON.parse(sessionStorage.getItem("property") || "null");
  return (
    <div className="ew-page">
      {workspace ? (
        <Tasklist />
      ) : (
        <div className="ew-empty">
          Select a workspace to view its tasks.{" "}
          <Link to="/Employee/work-dashboard">Back to dashboard</Link>
        </div>
      )}
    </div>
  );
};

export default Employeeworkspace;
